import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getProgramsCategory } from './programsCategory.selectors';

export const selectLLPATypes = createSelector(getProgramsCategory, ({ llpaTypes }) => llpaTypes);

const selectLLPATypesValues = createSelector(selectLLPATypes, llpaTypes =>
  Object.values(llpaTypes).sort((a, b) => a.name.localeCompare(b.name)),
);

export const selectLLPATypesValuesWithDeletedPostfix = createSelector(
  selectLLPATypesValues,
  llpaTypes =>
    llpaTypes.map(option => ({
      ...option,
      name: option.isDeleted ? `${option.name} (deleted)` : option.name,
    })),
);

export const selectLLPATypesValuesWithoutDeleted = createSelector(
  selectLLPATypesValues,
  llpaTypes => llpaTypes.filter(option => !option.isDeleted),
);

export const selectLLPATypesOptionsWithoutDeleted = createSelector(
  selectLLPATypesValuesWithoutDeleted,
  llpaTypes =>
    llpaTypes.map(option => ({
      ...option,
      value: option.llpaTypeId,
    })),
);

export const selectFilteredLLPATypes = createSelector(
  getDebouncedSearchValue,
  selectLLPATypesValues,
  searchItems(({ name }) => [name]),
);
